import {
  Timeline,
  TimelineConnector, TimelineContent, TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  timelineOppositeContentClasses,
  TimelineSeparator
} from "@mui/lab";
import { Box, Typography } from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../firebase"; // your firebase config

const EventTimeline = ({ eventDocId }) => {
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSchedule = async () => {
      try {
        const scheduleRef = collection(db, "events", eventDocId, "schedule");
        const snapshot = await getDocs(scheduleRef);
        const items = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        // Optional: sort by time if needed
        const sorted = items.sort((a, b) => new Date(`1970/01/01 ${a.time}`) - new Date(`1970/01/01 ${b.time}`));
        setSchedule(sorted);
      } catch (error) {
        console.error("Error fetching schedule:", error);
      } finally {
        setLoading(false);
      }
    };

    if (eventDocId) fetchSchedule();
  }, [eventDocId]);

  if (loading) return <p>Loading speakers...</p>;
  if (schedule.length === 0) return <p>No speakers available for this event.</p>;

  return (
    <Box sx={{ p: 3, maxWidth: "1200px", margin: "auto", textAlign: "center", }}>

      <Typography variant="h3" fontWeight="bold" gutterBottom>
        Schedule
      </Typography>
      <Timeline
        sx={{
          [`& .${timelineOppositeContentClasses.root}`]: {
            flex: 0.2,
          },
        }}
      >
        {schedule.map(item => (

          <TimelineItem key={item.id}>
            <TimelineOppositeContent color="textSecondary">
              {item.time}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Typography variant="body1" color="textSecondary">
                {item.activity}
              </Typography>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </Box>
  );
};

export default EventTimeline;
